<!-- <p>preconsultation-card works!</p> -->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="list-product p-2">
        <lib-crud
          [newLabel]="'Add Pre Consultation'"
          [items]="preconsultationList"
          (actionHandler)="handleEvent($event)"
          (deleteActionHandler)="deleteRecord($event)"
          [closePopup]="closeFormEvent"
          [openEditPopup]="editRecord"
          [popupWidthPercent]="'55'"
          [openDeletePopup]="openDeletePopup"
        >
          <!-- [formPopup]="actionForm" -->
          <form class="row" formsElement #preconsultationForm="ngForm">
            <div class="container-fluid">
              <div
                class="row"
                style="height: 100%; min-height: 100vh; overflow: hidden;"
              >
                <!-- Left Sidebar -->
                <div class="col-md-2 border-end p-0 d-flex flex-column">
                  <div class="p-2 border-bottom">
                    <h6 class="mb-1 fw-bold">Patient</h6>
                  </div>

                  <!-- Tabs for Queue and Search -->
                  <div class="flex-grow-1 overflow-auto p-2">
                    <p-tabView [(activeIndex)]="pationtIndex">
                      <!-- Queue Tab -->
                      <p-tabPanel header="Queue">
                        <div
                          class="list-group list-group-flush"
                          style="padding: 0px 0px !important; margin: 0px 0px;"
                        >
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                          >
                            Amit Virkar
                            <span class="text-muted">12:30 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-green"
                          >
                            Rohan Shinde
                            <span class="text-muted">01:00 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                          >
                            Priya Sharma
                            <span class="text-muted">01:30 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                          >
                            Arjun Desai
                            <span class="text-muted">02:00 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-blue"
                          >
                            Neha Kulkarni
                            <span class="text-muted">02:30 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-purple"
                          >
                            Sagar Patil
                            <span class="text-muted">03:00 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                          >
                            Kiran Joshi
                            <span class="text-muted">03:30 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-blue"
                          >
                            Meera Deshmukh
                            <span class="text-muted">04:00 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                          >
                            Rahul Chavan
                            <span class="text-muted">04:30 PM</span>
                          </button>
                          <button
                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-green"
                          >
                            Anjali Nair
                            <span class="text-muted">05:00 PM</span>
                          </button>
                        </div>
                      </p-tabPanel>

                      <!-- Search Tab -->
                      <p-tabPanel header="Search">
                        <div class="mb-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Search preconsultation..."
                          />
                        </div>
                        <div class="list-group list-group-flush">
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Amit Joshi
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Kavita Rao
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Suresh Patil
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-purple"
                          >
                            Meena Shah
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Ravi Kulkarni
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-purple"
                          >
                            Sneha Deshmukh
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-purple"
                          >
                            Vikas Jadhav
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Pooja Bhosale
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-yellow"
                          >
                            Anil Chavan
                          </button>
                          <button
                            class="list-group-item list-group-item-action bg-light-purple"
                          >
                            Neha Patankar
                          </button>
                        </div>
                      </p-tabPanel>
                    </p-tabView>
                  </div>
                </div>

                <!-- Right Content -->
                <div class="col-md-10 p-2">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="p-2 border-bottom">
                        <h5 class="mb-1 fw-bold">Pre Consultation </h5>
                      </div>

                    </div>
                  </div>

                  <div class="row">
  <div class="col-md-3">
    <label style="margin-top: 10px;">Patient ID</label>
    <input name="id" type="number" class="form-control" style="background-color: #fff8e6;" [(ngModel)]="preconsultation.id">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Blood Pressure</label>
    <input name="bp" type="text" class="form-control" style="background-color: #fff8e6;" placeholder="e.g., 120/80" [(ngModel)]="preconsultation.bp">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Pulse Rate (bpm)</label>
    <input name="pulseRate" type="number" class="form-control" style="background-color: #e4f3ff;" [(ngModel)]="preconsultation.pulseRate">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Temperature (°C)</label>
    <input name="temperature" type="number" class="form-control" style="background-color: #e4f3ff;" [(ngModel)]="preconsultation.temperature">
  </div>
</div>

<div class="row mt-2">
  <div class="col-md-3">
    <label style="margin-top: 10px;">Weight (kg)</label>
    <input name="weight" type="number" class="form-control" style="background-color: #fff8e6;" [(ngModel)]="preconsultation.weight">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Height (cm)</label>
    <input name="height" type="number" class="form-control" style="background-color: #fff8e6;" [(ngModel)]="preconsultation.height">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Fasting Blood Sugar (mg/dL)</label>
    <input name="fastingBloodSugar" type="number" class="form-control" style="background-color: #e4f3ff;" [(ngModel)]="preconsultation.fastingBloodSugar">
  </div>

  <div class="col-md-3">
    <label style="margin-top: 10px;">Oxygen Saturation (%)</label>
    <input name="oxygenSaturation" type="number" class="form-control" style="background-color: #e4f3ff;" [(ngModel)]="preconsultation.oxygenSaturation">
  </div>
</div>

<hr style="margin-top: 15px;">

<div class="row">
  
    <div class="col-md-3">
     <label class="d-block">Cold / Runny Nose</label>
                              <div class="form-check form-switch">
                                <input id="coldRunnyNose" name="coldRunnyNose" class="form-check-input" type="checkbox" [(ngModel)]="preconsultation.coldRunnyNose">
                                <label class="form-check-label" for="coldRunnyNose">Cold</label>
                                </div>
  </div>

  

    <div class="col-md-3">
     <label class="d-block"> Cough</label>
                              <div class="form-check form-switch">
                                <input id="cough" name="cough" class="form-check-input" type="checkbox" [(ngModel)]="preconsultation.cough">
                                <label class="form-check-label" for="cough">Cough</label>
                                </div>
  </div>

  <div class="col-md-6">
    <label style="margin-top: 10px;">Current Complaints</label>
    <textarea name="currentComplaints" rows="2" class="form-control" style="background-color: #fff8e6;" [(ngModel)]="preconsultation.currentComplaints"></textarea>
  </div>
</div>

                  

                </div>
              </div>
            </div>
          </form>

          <!-- Footer Buttons -->
          <div class="row" footerButtons>
            <div class="col-md-12 text-end">
              <button
                class="btn btn-outline-primary me-2"
                [disabled]="preconsultationForm.invalid"
                (click)="processpreconsultation()"
              >
                <i class="pi pi-check"></i>
                {{ preconsultation.id ? "Update" : "Add" }} preconsultation
              </button>
              <button class="btn btn-outline-primary" (click)="closeForm()">
                <i class="pi pi-times"></i> Cancel
              </button>
            </div>
          </div>
        </lib-crud>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog [style]="{ width: '100%' }" />
